export * from './PaginationControl';

export { default } from './PaginationControl';
